import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'record': [],
  'loading': false,
};

export const recordFTR = (state = INITIAL_STATE, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_RECORD_MESSAGES_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_RECORD_MESSAGES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'record': action.response.data,
    }),
    [ActionTypes.FETCHED_RECORD_MESSAGES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'record': [],
    }),
  })(state, action);
};
